<template>
  <div>
    <!-- <validation-observer ref="playerValidation"> -->
    <b-modal
      id="modal-scrollable"
      v-model="$store.state.someVariables.showNewDelegado"
      scrollable
      no-close-on-backdrop
      title="Agregar / Editar Delegado"
      @hidden="resetModal"
      cancel-variant="outline-secondary"
    >
      <b-row>
        <b-col cols="12" md="4">
          <croppa
            v-model="croppaFoto"
            :width="170"
            :height="200"
            placeholder="Subir foto jugador"
            placeholder-color="#543338"
            :placeholder-font-size="16"
            canvas-color="transparent"
            :show-remove-button="disabledObj.foto"
            remove-button-color="black"
            :show-loading="false"
            :loading-size="50"
            loading-color="#606060"
            :quality="1"
            :initial-image="getProxy(playerSelected.foto_jug)"
          ></croppa>
        </b-col>
        <b-col cols="12" md="5" class="ml-1">
          <croppa
            v-model="croppaCedula"
            :width="290"
            :height="200"
            placeholder="Subir frontal cedula"
            placeholder-color="#543338"
            :placeholder-font-size="16"
            canvas-color="transparent"
            :show-remove-button="true"
            remove-button-color="black"
            :show-loading="false"
            :loading-size="50"
            loading-color="#606060"
            :initial-image="getProxy(playerSelected.foto_cedula)"
          ></croppa>
        </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col md="12">
          <v-select
            ref="refCi"
            id="input-ci-pasaporte"
            :options="listPlayers"
            placeholder="C.I / PASAPORTE *"
            outlined
            taggable
            v-model="playerSelected.ci_pasaporte"
            @search="searchPlayer"
            @input="changePlayer"
            :disabled="disabledObj.buscador"
            :clearable="
              $store.state.someVariables.actionPlayer == UPDATE_DATA_PLAYER
                ? false
                : true
            "
            class="mt-1"
          ></v-select>
        </b-col>
        <b-col md="12" class="mt-1">
          <v-select
            placeholder="Seleccione Institucion"
            id="input-institucion"
            :options="instituciones"
            :clearable="false"
            style="width: 100%"
            v-model="playerSelected.institucion"
          />
        </b-col>
        <b-col md="12" style="margin-top:6px">
          <div class="form-label-group">
            <b-form-input
              id="floating-nombres"
              placeholder="Ingrese Nombres *"
              :formatter="formatter"
              v-model="playerSelected.nombres"
              :disabled="disabledObj.nombres"
              class="mt-1"
            />
            <label for="floating-nombres">Nombres</label>
          </div>
        </b-col>
        <b-col md="12" style="margin-top:6px">
          <div class="form-label-group">
            <b-form-input
              id="floating-apellidos"
              placeholder="Ingrese Apellidos *"
              :formatter="formatter"
              v-model="playerSelected.apellidos"
              :disabled="disabledObj.apellidos"
            />
            <label for="floating-apellidos">Apellidos</label>
          </div>
        </b-col>
        <b-col md="12">
          <div class="form-label-group">
            <b-form-input
              id="floating-nacimiento"
              type="date"
              v-model="playerSelected.fecha_nac"
              :disabled="disabledObj.fechaNacimiento"
              class="mt-1"
            />
            <label for="floating-nacimiento">Fecha de nacimiento *</label>
          </div>
        </b-col>
        <template
          v-if="
            USER().rol === `${ROLES.ADMIN}` ||
              USER().rol === `${ROLES.SUPER}` ||
              USER().rol === `${ROLES.CALIFICACION}`
          "
        >
          <div style="background:#EAEAEC; width:100%; padding:10px">
            <b-col md="12">
              <b-form-file
                v-model="filesFotos"
                placeholder="Fotos para Reconocimiento facial..."
                drop-placeholder="Drop file here..."
                multiple
            /></b-col>
            <b-col class="mt-1 text-center">
              <b-button
                v-if="!showLoadingProcesar"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="outline-primary"
                size="sm"
                @click="procesarImagenes"
              >
                <span>procesar</span>
              </b-button>
              <div v-if="showLoadingProcesar" class="text-center mt-1">
                <b-spinner variant="primary" label="Text Centered" />
              </div>
            </b-col>
          </div>
        </template>
        <b-col
          v-if="
            $store.getters['someVariables/getActionDelegado'] ===
              INSERT_DATA_HISTORY_PLAYER
          "
          md="12"
          style="color:black;background:#ffc107; font-size:11px; padding:10px;border-radius:4px"
        >
          <span
            >Está en el modo <b>“Agregar Delegado por cédula”</b>. Si necesita
            actualizar la información de un delegado, primero debe agregarlo y
            luego editar sus datos desde el listado.</span
          >
        </b-col>
      </b-row>
      <template #modal-footer>
        <div class="w-100">
          <b-row>
            <b-col md="12">
              <!-- <div class="d-block">
                <p class="inscrito">
                  Inscrito: {{ playerSelected.fecha_inscripcion }}
                </p>
              </div> -->
            </b-col>

            <b-col class="mt-1">
              <template v-if="!showLoading">
                <b-button
                  v-if="
                    (USER().rol === `${ROLES.ADMIN}` ||
                      USER().rol === `${ROLES.SUPER}` ||
                      USER().rol === `${ROLES.SECRETARIA}`) &&
                      playerSelected.from_delegado
                  "
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="float-right"
                  @click="savePlayer"
                >
                  <span>{{ actionPlayer }}</span>
                </b-button>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="outline-primary"
                  class="float-right mr-1"
                  @click="onlyClose"
                >
                  Cancelar
                </b-button>
              </template>
              <div v-if="showLoading" class="text-center mt-1">
                <b-spinner variant="primary" label="Text Centered" />
              </div>
            </b-col>
          </b-row>
          <b-alert
            :show="dismissCountDown"
            v-height-fade.appear
            :variant="variante"
            style="position:absolute; bottom:55px;  width:92%; margin-left:-4px"
            @dismiss-count-down="countDownChanged"
          >
            <div
              :class="{
                'alert-body danger': variante == 'danger',
                'alert-body success': variante == 'success',
              }"
            >
              {{ messageError }}
            </div>
          </b-alert>
        </div>
      </template>
      <!-- <b-button ref="hola" @click="holaMundo">
        aplasta
      </b-button> -->
    </b-modal>
    <!-- </validation-observer> -->
  </div>
</template>
<script>
// import { ValidationProvider, ValidationObserver } from 'vee-validate'
// import { required, email } from '@validations'
import vSelect from 'vue-select'
import { heightFade } from '@core/directives/animations'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import {
  watch,
  // watchEffect,
  computed,
  // reactive,
  ref,
  // onUpdated,
} from '@vue/composition-api'

// import Cleave from 'vue-cleave-component'
import {
  BModal,
  BRow,
  BCol,
  BFormInput,
  // BFormTextarea,
  BAlert,
  BButton,
  BSpinner,
  VBPopover,
  BFormFile,
  // VBTooltip,
  //   BForm,
  //   BInputGroup,
  //   BInputGroupPrepend,
} from 'bootstrap-vue'

import apiCall from '../../utils/apiCall'

import {
  URL,
  URL_PROXY,
  USER,
  ROLES,
  ESTADO_JUGADOR,
  INSERT_DATA_PLAYER,
  INSERT_DATA_HISTORY_PLAYER,
  UPDATE_DATA_PLAYER,
  URL_PROCESO_IMAGENES,
} from '../../utils/variables'

const moment = require('moment-timezone')

moment.tz.setDefault('America/Guayaquil')

export default {
  components: {
    BModal,
    BRow,
    BCol,
    // vSelect,
    BFormInput,
    // BFormTextarea,
    vSelect,
    // ValidationProvider,
    // ValidationObserver,
    // Cleave,
    BAlert,
    BButton,
    BSpinner,
    BFormFile,
    // BForm,
    // BInputGroup,
    // BInputGroupPrepend,
  },
  directives: {
    'b-popover': VBPopover,
    // 'b-tooltip': VBTooltip,
    heightFade,
    Ripple,
  },
  props: {
    playerSelected: Object,
    playerAuxiliar: Object,
    campeonatoSeleccionado: Object,
    posiciones: Array,
    tiposAdicional: Array,
    listCategorias: Array,
    instituciones: Array,
  },
  setup(props, { emit }) {
    // console.log('setup modal')
    // console.log(props.isAbierto)
    const croppaFoto = ref({})
    const userEmail = ref('')
    const croppaCedula = ref({})
    const listPlayers = ref([])
    const filtered = ref([])
    const filesFotos = ref([])
    const listEquiposTransferir = ref([])
    const { getApi, postApi } = apiCall()
    const selectedRadio = ref('active')
    const disabledInputs = ref(false)
    // eslint-disable-next-line
    const disabledObservacion = ref(USER().rol === ROLES.CLUB ? true : false)
    const isPassportOther = ref(false)
    const hasError = ref(false)
    const showLoading = ref(false)
    const showLoadingProcesar = ref(false)
    const messageError = ref('')
    const variante = ref('danger')
    const refCi = ref()
    const dismissCountDown = ref(0)
    const dismissSecs = ref(3)
    const popoverShow = ref(true)
    const checkClasificado = ref(false)
    const { postApiFormData } = apiCall()
    // const observ = ref(['la fotografia ha sido actualizada', 'dso'])
    const optionsEstadoJugador = ref([
      {
        text: 'Inscrito',
        value: 'inscrito',
        disabled: false,
        selected: true,
      },
      { text: 'Revisado', value: 'revisado', disabled: false },
      { text: 'Calificado', value: 'calificado', disabled: false },
    ])
    // const observaciones = computed(() => {
    //   const arrayReturn = []
    //   if (props.playerSelected.observaciones !== undefined) {
    //     props.playerSelected.observaciones.forEach(element => {
    //       arrayReturn.push(element.mensaje)
    //     })
    //   }
    //   return arrayReturn
    // })
    const getProxy = url =>
      // eslint-disable-next-line
      `${URL_PROXY}${encodeURIComponent(url)}`
    const actionPlayer = computed(() => {
      let texto = 'Guardar'
      if (
        store.getters['someVariables/getActionDelegado'] === INSERT_DATA_PLAYER
      ) {
        texto = 'Guardar'
      } else if (
        store.getters['someVariables/getActionDelegado'] ===
        INSERT_DATA_HISTORY_PLAYER
      ) {
        texto = 'Agregar'
      } else if (
        store.getters['someVariables/getActionDelegado'] === UPDATE_DATA_PLAYER
      ) {
        texto = 'Actualizar'
      }
      return texto
    })
    const disabledObj = computed(() => {
      const objDisabled = {
        buscador: false,
        nombres: false,
        apellidos: false,
        fechaNacimiento: false,
        direccion: false,
        telefono: false,
        email: false,
        foto: true,
      }
      const action = store.getters['someVariables/getActionDelegado']
      // console.log('action', action)
      if (action === INSERT_DATA_PLAYER) {
        objDisabled.buscador = false
        objDisabled.nombres = false
        objDisabled.apellidos = false
        objDisabled.fechaNacimiento = false
      } else if (action === INSERT_DATA_HISTORY_PLAYER) {
        objDisabled.nombres = true
        objDisabled.apellidos = true
        objDisabled.fechaNacimiento = true
      } else if (action === UPDATE_DATA_PLAYER) {
        if (props.playerSelected.nuevo === 'n') {
          // console.log('nuevo n')
          objDisabled.buscador = true
          objDisabled.nombres = true
          objDisabled.apellidos = true
          objDisabled.fechaNacimiento = true
          objDisabled.foto = false
        }
        if (
          USER().editar_player &&
          (USER().rol === ROLES.SUPER ||
            USER().rol === ROLES.ADMIN ||
            USER().rol === ROLES.CALIFICACION)
        ) {
          objDisabled.buscador = false
          objDisabled.nombres = false
          objDisabled.apellidos = false
          objDisabled.fechaNacimiento = false
          objDisabled.foto = true
        }
        if (
          props.playerSelected.permiso_editar_personal &&
          USER().rol === ROLES.CLUB
        ) {
          objDisabled.buscador = true
          objDisabled.nombres = false
          objDisabled.apellidos = false
          objDisabled.fechaNacimiento = false
          objDisabled.foto = true
        }
      }
      // console.log('aqui')
      // console.log(action, props.playerSelected.nuevo)
      // if (props.playerSelected.nuevo === 'n') {
      //   objDisabled.buscador = true
      //   objDisabled.nombres = true
      //   objDisabled.apellidos = true
      //   objDisabled.fechaNacimiento = true
      // }
      // let disabled = false
      // if (props.playerSelected.nuevo === 'n') {
      //   disabled = true
      // }
      // console.log(disabled)
      return objDisabled
    })
    const optionsEstado = computed(() => {
      if (USER().rol === ROLES.CLUB) {
        if (props.playerSelected.estado_jug === ESTADO_JUGADOR.INSCRITO) {
          optionsEstadoJugador.value[0].selected = true
          optionsEstadoJugador.value[0].disabled = false
          optionsEstadoJugador.value[1].disabled = true
          optionsEstadoJugador.value[2].disabled = true
        } else if (
          props.playerSelected.estado_jug === ESTADO_JUGADOR.REVISADO
        ) {
          optionsEstadoJugador.value[1].selected = true
          optionsEstadoJugador.value[1].disabled = false
          optionsEstadoJugador.value[0].disabled = true
          optionsEstadoJugador.value[2].disabled = true
        } else if (
          props.playerSelected.estado_jug === ESTADO_JUGADOR.CALIFICADO
        ) {
          optionsEstadoJugador.value[2].selected = true
          optionsEstadoJugador.value[2].disabled = false
          optionsEstadoJugador.value[0].disabled = true
          optionsEstadoJugador.value[1].disabled = true
        }
      }
      if (
        USER().rol === ROLES.SUPER ||
        USER().rol === ROLES.ADMIN ||
        USER().rol === ROLES.CALIFICACION
      ) {
        if (props.playerSelected.estado_jug === ESTADO_JUGADOR.CALIFICADO) {
          props.playerSelected.permiso_editar_personal = false
        }
      }
      // else if (
      //   USER().rol === ROLES.ADMIN ||
      //   USER().rol === ROLES.SUPER ||
      //   USER().rol === ROLES.CALIFICACION
      // ) {
      //   if (props.playerSelected.estado_jug === ESTADO_JUGADOR.CALIFICADO) {
      //     // observacionesAuxiliar = props.playerSelected.observaciones
      //     props.playerSelected.observaciones = []
      //   }
      // }
      return optionsEstadoJugador.value
    })

    // watchEffect(() => croppaFoto.value.refresh())
    // watch(fotoHistorial, (despues, antes) => {
    //   console.log(`watchRefAnt: ${antes}`)
    //   props.playerSelected.foto_jug = despues
    //   console.log(`watchRefDes: ${despues}`)
    //   croppaFoto.value.refresh()
    // })
    // const showNewPlayer = ref(true)
    // onUpdated(() => {
    //   // console.log(`updated() val: `)
    //   this.croppaFoto.value.refresh()
    // })
    function showMessageAlert(type, mensaje) {
      variante.value = type
      hasError.value = true
      messageError.value = mensaje
      dismissCountDown.value = dismissSecs.value
    }
    async function updateFacialIdV3(idJugador, embending, message) {
      const path = 'ApiInscripciones/updateFacialIdv3'
      const data = {
        id_jugador: idJugador,
        embed: embending,
        movimiento: `Actualiza Facial ID de jugador con C.I ${props.playerSelected.ci_pasaporte}, ${message}`,
        id_user: USER().id_usuario,
        id_torneo:
          store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
      }
      const response = await postApi(URL, path, data)
      if (response.flag === 'si') {
        showMessageAlert('success', `Exitos ${message}`)
        emit('updateFacial')
      }
    }

    async function procesarImagenes() {
      // console.log(filesFotos.value)
      if (filesFotos.value.length <= 1) {
        showMessageAlert('danger', 'debes seleccionar al menos 2 fotografías')
        return
      }
      showLoadingProcesar.value = true
      const path = URL_PROCESO_IMAGENES
      const archivo = new FormData()
      if (filesFotos.value != null) {
        filesFotos.value.forEach(file => {
          archivo.append('images[]', file) // Usamos "file[]" para múltiples archivos
        })
      }
      // console.log(dataNoticia)
      // const path = 'ApiInscripciones/guardarImagenes'
      // const response = await postApiFormData(URL, path, archivo)
      const response = await postApiFormData(path, '', archivo)
      if (response.flag === 'si') {
        updateFacialIdV3(
          props.playerSelected.id_jugador,
          response.embending,
          // eslint-disable-next-line
          response.message,
        )
      }
      filesFotos.value = []
      showLoadingProcesar.value = false
      // console.log(response)
    }

    function automatizeObservacion(newValue) {
      const size = newValue.length
      if (
        size > 0 &&
        props.playerSelected.estado_jug === ESTADO_JUGADOR.REVISADO
      ) {
        // console.log('mayor que cero')
        props.playerSelected.estado_jug = 'revisado'
      }
    }
    function countDownChanged(dismissCountDownAux) {
      dismissCountDown.value = dismissCountDownAux
    }
    function formatter(value) {
      return value.toUpperCase()
    }
    function setCroppaRefresh() {
      setTimeout(() => {
        croppaFoto.value.refresh()
        croppaCedula.value.refresh()
      }, 100)
    }

    function initPlayer() {
      props.playerSelected.nombres = ''
      props.playerSelected.apellidos = ''
      props.playerSelected.fecha_nac = ''
      props.playerSelected.num_camiseta = ''
      props.playerSelected.direccion = ''
      props.playerSelected.telefono = ''
      props.playerSelected.email = ''
      props.playerSelected.foto_jug = ''
      props.playerSelected.foto_cedula = ''
      props.playerSelected.id_jugador = null
      props.playerSelected.edad = 0
      props.playerSelected.institucion = {
        label: 'Seleccione Institucion',
        value: null,
      }
      disabledInputs.value = false
      store.commit('someVariables/UPDATE_ACTION_PLAYER', INSERT_DATA_PLAYER)
      setCroppaRefresh()
    }
    function resetModal(bvModalEvt) {
      bvModalEvt.preventDefault()
      // emit('recargar', props.playerSelected.id_equipo)
      hasError.value = false
      listPlayers.value = []
      showLoading.value = false
      countDownChanged(0)
      // initPlayer()
      //       this.$emit('closeModal', false)
    }
    function onlyClose() {
      store.commit('someVariables/UPDATE_SHOW_NEW_DELEGADO', false)
      showLoading.value = false
    }
    function calculateTypePlayer(dataCategoria) {
      // console.log(dataCategoria)
      if (dataCategoria.tieneJuvenil === 's') {
        if (dataCategoria.validarPorAnios === 's') {
          const isJuvenil = moment(props.playerSelected.fecha_nac).isBetween(
            dataCategoria.fechaMinJuvenil,
            dataCategoria.fechaMaxJuvenil,
            undefined,
            // eslint-disable-next-line
            '[]',
          )
          props.playerSelected.tipoJugador = isJuvenil ? 'JUVENIL' : 'NOVATO'
          checkClasificado.value = false
        } else {
          const [
            anioInicial,
            mesInicial,
            anioFinal,
            mesFinal,
          ] = dataCategoria.limitesAnios
          const diffDuration = moment.duration(
            // eslint-disable-next-line
            moment().diff(props.playerSelected.fecha_nac),
          )
          const anio = diffDuration.years()
          const mes = diffDuration.months()

          if (anio >= Number(anioInicial) && anio <= Number(anioFinal)) {
            if (mes >= Number(mesInicial) && mes <= Number(mesFinal)) {
              props.playerSelected.tipoJugador = 'JUVENIL'
            } else {
              props.playerSelected.tipoJugador = 'NOVATO'
            }
          } else {
            props.playerSelected.tipoJugador = 'NOVATO'
          }
        }
      } else {
        props.playerSelected.tipoJugador = 'NOVATO'
      }
    }
    watch(checkClasificado, despues => {
      // console.log(despues)
      if (despues) {
        props.playerSelected.tipoJugador = 'CLASIFICADO'
      } else {
        calculateTypePlayer(props.playerSelected.dataCategoria)
      }
    })
    function calculateAge(date) {
      // const years = moment().diff(date, 'YYYY-MM-DD')
      const diffDuration = moment.duration(moment().diff(date))
      props.playerSelected.edad = `${diffDuration.years()} años, ${diffDuration.months()} meses, ${diffDuration.days()} dias`
      calculateTypePlayer(props.playerSelected.dataCategoria)
    }
    // const showNewPlayer = computed(() => props.isOpen)
    async function searchPlayer(value) {
      // console.log(value)
      // console.log(props.playerSelected)
      const action = store.getters['someVariables/getActionDelegado']
      if (action === INSERT_DATA_PLAYER) {
        if (value.length) {
          const path = `ApiInscripciones/getDelegadosCedula/${value}`
          const data = await getApi(URL, path)
          // this.listPlayers.value = data.jugadores
          if (data.flag === 'si') {
            listPlayers.value = []
            data.jugadores.forEach(element => {
              const obj = {
                label: `${element.ci_pasaporte}`,
                value: element.id_jugador,
                apellidos: element.apellidos,
                nombres: element.nombres,
                direccion: element.direccion,
                email: element.email,
                telefono: element.telefono,
                fecha_nac: element.fecha_nac,
                nuevo: element.nuevo,
                edad: element.edad,
                foto_jug: element.foto_jug,
                foto_cedula: element.foto_cedula,
                id_jugador: element.id_jugador || null,
                from_delegado: element.from_delegado || false,
              }
              listPlayers.value.push(obj)
            })
          } else {
            // props.playerSelected.ci_pasaporte = value
            initPlayer()
          }
        } else {
          // this.listCI = []
          // this.deHistorial=false;
          // console.log("ssss");
        }
      }
      //  trigger a mutation, or dispatch an action
    }
    function desabilitarEnHistorial(obj) {
      obj.nombres = true
      obj.apellidos = true
      obj.direccion = true
      obj.telefono = true
      obj.email = true
      obj.fechaNacimiento = true
    }

    function setearDatosDeHistorial(item) {
      props.playerSelected.id_jugador = item.id_jugador
      props.playerSelected.nombres = item.nombres
      props.playerSelected.apellidos = item.apellidos
      props.playerSelected.email = item.email
      props.playerSelected.fecha_nac = item.fecha_nac
      props.playerSelected.telefono = item.telefono
      props.playerSelected.direccion = item.direccion
      props.playerSelected.posicion = item.posicion
      props.playerSelected.rol = USER().rol
      props.playerSelected.foto_jug = item.foto_jug
      props.playerSelected.foto_cedula = item.foto_cedula
      props.playerSelected.edad = item.edad
      props.playerSelected.nuevo = item.nuevo
      props.playerSelected.estado_jug = 'inscrito'
      disabledInputs.value = true
      calculateTypePlayer(props.playerSelected.dataCategoria)
      desabilitarEnHistorial(disabledObj.value)
      setCroppaRefresh()
    }

    function changePlayer(item) {
      let action = store.getters['someVariables/getActionDelegado']
      // console.log(item)
      if (item !== null) {
        if (action !== UPDATE_DATA_PLAYER) {
          if (item.id_jugador === undefined) {
            // console.log('accion insertar jugador')
            props.playerSelected.from_delegado = true
            action = INSERT_DATA_PLAYER
          } else {
            // console.log('accion insertar jugador de historial')
            action = INSERT_DATA_HISTORY_PLAYER
            props.playerSelected.from_delegado = true
            setearDatosDeHistorial(item)
            // getListEquiposUltimosJugo(item.id_jugador)
          }
        }
        store.commit(
          'someVariables/UPDATE_ACTION_DELEGADO',
          // eslint-disable-next-line
          action,
        )
        // console.log(action)
      } else {
        initPlayer()
      }
    }
    function focusInput(id, error) {
      document.getElementById(id).focus()
      messageError.value = error
    }
    function hasErrorForm() {
      // console.log(refCi)
      let error = false
      if (
        props.playerSelected.ci_pasaporte === '' ||
        props.playerSelected.ci_pasaporte === null ||
        props.playerSelected.ci_pasaporte === undefined
      ) {
        focusInput('input-ci-pasaporte', 'C.I o Passaporte es requerido')
        error = true
      } else if (
        props.playerSelected.nombres === '' ||
        props.playerSelected.nombres === null ||
        props.playerSelected.nombres === undefined
      ) {
        focusInput('floating-nombres', 'Nombres es requerido')
        error = true
      } else if (
        props.playerSelected.apellidos === '' ||
        props.playerSelected.apellidos === null ||
        props.playerSelected.apellidos === undefined
      ) {
        focusInput('floating-apellidos', 'Apellidos es requerido')
        error = true
      } else if (
        props.playerSelected.fecha_nac === '' ||
        props.playerSelected.fecha_nac === null ||
        props.playerSelected.fecha_nac === undefined
      ) {
        focusInput('floating-nacimiento', 'Fecha de nacimiento es requerido')
        error = true
      } else if (
        props.playerSelected.institucion.value === '' ||
        props.playerSelected.institucion.value === null ||
        props.playerSelected.institucion.value === undefined
      ) {
        focusInput('input-institucion', 'Institución del jugador es requerida')
        error = true
      } else {
        error = false
      }
      return error
    }
    function getPicturePlayer(croppa) {
      let fotografia = ''
      if (croppa.value.chosenFile == null) {
        fotografia = ''
      } else {
        const fotografiaBase64 = croppa.value.generateDataUrl(
          'image/jpeg',
          // eslint-disable-next-line
          0.5,
        )
        fotografia = fotografiaBase64
      }
      return fotografia
    }

    function isNullPosition(position) {
      let pos = ''
      if (position !== null) {
        pos = position.value
      } else {
        pos = ''
      }
      return pos
    }

    function getStringChanges() {
      // let has = false
      // console.log(props.playerSelected)

      let stringFinal = ''
      if (
        props.playerAuxiliar.ci_pasaporte !== props.playerSelected.ci_pasaporte
      ) {
        stringFinal += `cambia cedula de ${props.playerAuxiliar.ci_pasaporte} a ${props.playerSelected.ci_pasaporte} `
      }
      if (props.playerAuxiliar.nombres !== props.playerSelected.nombres) {
        stringFinal += `cambia nombres de ${props.playerAuxiliar.nombres} a ${props.playerSelected.nombres} `
      }
      if (props.playerAuxiliar.apellidos !== props.playerSelected.apellidos) {
        stringFinal += `cambia apellidos de ${props.playerAuxiliar.apellidos} a ${props.playerSelected.apellidos} `
      }
      if (props.playerAuxiliar.fecha_nac !== props.playerSelected.fecha_nac) {
        stringFinal += `cambia fecha nacimiento de ${props.playerAuxiliar.fecha_nac} a ${props.playerSelected.fecha_nac} `
      }
      if (props.playerSelected.fotografia !== '') {
        stringFinal += 'cambia fotografía '
      }
      if (props.playerSelected.fotografia_cedula !== '') {
        stringFinal += 'cambia fotografía cedula'
      }
      return stringFinal
    }
    // function marcaCalificado() {
    //   let calificado = false
    //   if (
    //     props.playerAuxiliar.estado_jug !== props.playerSelected.estado_jug &&
    //     props.playerSelected.estado_jug === ESTADO_JUGADOR.CALIFICADO
    //   ) {
    //     calificado = true
    //   }
    //   return calificado
    // }
    async function savePlayer() {
      // console.log(props.playerSelected)
      const action = store.getters['someVariables/getActionDelegado']
      hasError.value = hasErrorForm()
      if (!hasError.value) {
        showLoading.value = true
        if (action === INSERT_DATA_PLAYER) {
          const isObject = typeof props.playerSelected.ci_pasaporte === 'object'
          // console.log(isObject)
          if (isObject) {
            props.playerSelected.ci_pasaporte_env =
              props.playerSelected.ci_pasaporte.label
          } else {
            props.playerSelected.ci_pasaporte_env =
              props.playerSelected.ci_pasaporte
          }

          props.playerSelected.fotografia = getPicturePlayer(croppaFoto)
          props.playerSelected.fotografia_cedula = getPicturePlayer(
            // eslint-disable-next-line
            croppaCedula,
          )
          props.playerSelected.id_institucion = isNullPosition(
            // eslint-disable-next-line
            props.playerSelected.institucion,
          )
          // props.playerSelected.id_institucion =
          //   props.playerSelected.institucionAuxiliar.value
          props.playerSelected.rol = USER().rol
          props.playerSelected.id_campeonato =
            props.campeonatoSeleccionado.value
          // throw 'error'
          // this.openLoadingContained("#" + this.idButtonLogin);
          const path = 'ApiInscripciones/insertDelegado'
          props.playerSelected.idUserIngresa = USER().id_usuario
          const response = await postApi(URL, path, props.playerSelected)
          if (response.flag === 'si') {
            showMessageAlert('success', 'DELEGADO agregado exitosamente')
            emit('recargarHistorial', props.playerSelected.id_campeonato)
            initPlayer()
            props.playerSelected.ci_pasaporte = null
          } else {
            showMessageAlert('danger', response.mensaje)
          }
          showLoading.value = false
        } else if (action === INSERT_DATA_HISTORY_PLAYER) {
          props.playerSelected.rol = USER().rol
          props.playerSelected.id_torneo =
            store.getters['someVariables/getTorneoSeleccionado'].id_torneo

          props.playerSelected.id_campeonato =
            props.campeonatoSeleccionado.value
          props.playerSelected.id_institucion =
            props.playerSelected.institucion.value

          const path = 'ApiInscripciones/addHistorialDelegado'
          const response = await postApi(URL, path, props.playerSelected)
          if (response.flag === 'si') {
            emit('recargarHistorial', props.playerSelected.id_campeonato)
            showMessageAlert('success', 'DELEGADO agregado exitosamente')
            initPlayer()
            props.playerSelected.ci_pasaporte = null
          } else {
            showMessageAlert('danger', response.mensaje)
          }
          showLoading.value = false
        } else if (action === UPDATE_DATA_PLAYER) {
          props.playerSelected.id_campeonato =
            props.campeonatoSeleccionado.value
          props.playerSelected.id_institucion =
            props.playerSelected.institucion.value

          // props.playerSelected.id_posicion = props.playerSelected.posicion.value
          // props.playerSelected.id_posicion_ayuda = props.playerSelected.posicionAuxiliar.value
          props.playerSelected.fotografia = getPicturePlayer(croppaFoto)
          props.playerSelected.fotografia_cedula = getPicturePlayer(
            // eslint-disable-next-line
            croppaCedula,
          )
          // console.log(props.playerSelected.fotografia)
          // console.log(props.playerSelected.fotografia_cedula)

          // console.log(props.playerSelected.observaciones_enviar)
          props.playerSelected.rol = USER().rol

          const infoInicial = `Delegados  C.I: ${props.playerSelected.ci_pasaporte} `
          const dataMovimientoString = getStringChanges()
          const tieneCambios = dataMovimientoString === '' ? 'no' : 'si'
          props.playerSelected.hasChanges = tieneCambios
          props.playerSelected.dataMovimiento = `${infoInicial} ${dataMovimientoString}`
          // if (marcaCalificado()) {
          //   props.playerSelected.dataStatusPlayer = `${infoInicial} cambia status a CALIFICADO `
          // } else {
          //   props.playerSelected.dataStatusPlayer = ''
          // }
          props.playerSelected.dataStatusPlayer = ''
          props.playerSelected.idTorneo =
            store.getters['someVariables/getTorneoSeleccionado'].id_torneo

          const path = 'ApiInscripciones/actualizarDelegado'
          props.playerSelected.idUserIngresa = USER().id_usuario

          const response = await postApi(URL, path, props.playerSelected)
          if (response.flag === 'si') {
            emit('recargar', props.campeonatoSeleccionado.value)
            initPlayer()
            store.commit('someVariables/UPDATE_SHOW_NEW_DELEGADO', false)
          } else {
            showMessageAlert('danger', response.mensaje)
          }

          showLoading.value = false
        }
      } else {
        variante.value = 'danger'
        dismissCountDown.value = dismissSecs.value
      }
      // console.log(hasError.value)
      // console.log()
    }
    function initDePase() {
      emit('recargarHistorial', props.playerSelected.id_equipo)
      initPlayer()
      props.playerSelected.ci_pasaporte = null
    }

    return {
      userEmail,
      croppaFoto,
      croppaCedula,
      listPlayers,
      searchPlayer,
      filtered,
      changePlayer,
      initPlayer,
      selectedRadio,
      optionsEstadoJugador,
      disabledInputs,
      isPassportOther,
      savePlayer,
      hasErrorForm,
      hasError,
      messageError,
      refCi,
      showLoading,
      variante,
      resetModal,
      countDownChanged,
      dismissCountDown,
      dismissSecs,
      formatter,
      popoverShow,
      calculateAge,
      calculateTypePlayer,
      // defineIsClasificado,
      checkClasificado,
      ROLES,
      USER,
      ESTADO_JUGADOR,
      optionsEstado,
      disabledObservacion,
      onlyClose,
      disabledObj,
      automatizeObservacion,
      UPDATE_DATA_PLAYER,
      listEquiposTransferir,
      initDePase,
      actionPlayer,
      procesarImagenes,
      filesFotos,
      showLoadingProcesar,
      INSERT_DATA_HISTORY_PLAYER,
      getProxy,
      // observ,
      // observaciones,
      // holaMundo,
      // hola,
      // fotoHistorial,
    }
  },
}
</script>
<style>
.danger {
  background-color: #ea5454c7;
  border-radius: 5px;
  color: white;
}
.success {
  background-color: #2be025c7;
  border-radius: 5px;
  color: white;
}
.inscrito {
  margin: 0px;
  background: #e6e5e2;
  border-radius: 5px;
  padding-left: 5px;
  font-size: 12px;
}
.calificado {
  margin-top: 10px;
  background: #84ef96;
  border-radius: 5px;
  padding-left: 5px;
  font-size: 12px;
}
.recalificado {
  margin-top: 10px;
  background: #cbebd1;
  border-radius: 5px;
  padding-left: 5px;
  font-size: 12px;
}
</style>
